import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=51b3f245&scoped=true&"
import script from "./Bar.vue?vue&type=script&lang=ts&"
export * from "./Bar.vue?vue&type=script&lang=ts&"
import style0 from "./Bar.vue?vue&type=style&index=0&id=51b3f245&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b3f245",
  null
  
)

export default component.exports